// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Json from "../../primitives/Json.res.js";
import * as Future from "rescript-future/src/Future.res.js";
import * as Auth__Types from "./Auth__Types.res.js";
import * as Stdlib_Array from "@rescript/runtime/lib/es6/Stdlib_Array.js";
import * as Auth__Fetcher from "./Auth__Fetcher.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";

function encodeUser(user) {
  let dict = Object.fromEntries([
    [
      "organizationName",
      Json.encodeString(user.organizationName)
    ],
    [
      "id",
      Json.encodeString(user.id)
    ],
    [
      "name",
      Json.encodeString(user.name)
    ],
    [
      "username",
      Json.encodeString(user.username)
    ],
    [
      "canUseImpersonation",
      Json.encodeBoolean(user.canUseImpersonation)
    ],
    [
      "impersonating",
      Json.encodeBoolean(user.impersonating)
    ]
  ]);
  let profilePictureUri = user.profilePictureUri;
  if (profilePictureUri !== undefined) {
    dict["profilePictureUri"] = Json.encodeString(profilePictureUri);
  }
  return Json.encodeDict(dict);
}

function decodeUser(json) {
  let dict = Json.decodeDict(json);
  if (dict === undefined) {
    return;
  }
  let user;
  try {
    user = {
      id: Json.decodeDictFieldExn(dict, "id", Json.decodeString),
      name: Json.decodeDictFieldExn(dict, "name", Json.decodeString),
      organizationName: Json.decodeDictFieldExn(dict, "organizationName", Json.decodeString),
      profilePictureUri: Json.decodeDictOptionalField(dict, "profilePictureUri", Json.decodeString),
      username: Json.decodeDictFieldExn(dict, "username", Json.decodeString),
      canUseImpersonation: Stdlib_Option.getOr(Json.decodeDictOptionalField(dict, "canUseImpersonation", Json.decodeBoolean), false),
      impersonating: Stdlib_Option.getOr(Json.decodeDictOptionalField(dict, "impersonating", Json.decodeBoolean), false)
    };
  } catch (exn) {
    return;
  }
  return user;
}

function encodeShop(shop) {
  let dict = {};
  dict["name"] = Json.encodeString(shop.name);
  dict["id"] = Json.encodeString(shop.id);
  dict["corporateName"] = Json.encodeString(shop.corporateName);
  dict["activeWebDeviceId"] = Json.encodeString(shop.activeWebDeviceId);
  dict["loyaltyAddonActivated"] = Json.encodeBoolean(shop.loyaltyAddonActivated);
  dict["kind"] = Json.encodeString(Auth__Types.ShopKind.toString(shop.kind));
  dict["address"] = Json.encodeString(shop.address);
  dict["postalCode"] = Json.encodeString(shop.postalCode);
  dict["city"] = Json.encodeString(shop.city);
  dict["country"] = Json.encodeString(shop.country);
  dict["phoneNumber"] = Json.encodeString(shop.phoneNumber);
  dict["email"] = Json.encodeString(shop.email);
  let legalRepresentative = shop.legalRepresentative;
  if (legalRepresentative !== undefined) {
    dict["legalRepresentative"] = Json.encodeString(legalRepresentative);
  }
  let bankName = shop.bankName;
  if (bankName !== undefined) {
    dict["bankName"] = Json.encodeString(bankName);
  }
  let cityOfRegistryOffice = shop.cityOfRegistryOffice;
  if (cityOfRegistryOffice !== undefined) {
    dict["cityOfRegistryOffice"] = Json.encodeString(cityOfRegistryOffice);
  }
  let website = shop.website;
  if (website !== undefined) {
    dict["website"] = Json.encodeString(website);
  }
  let fiscalYearEndClosingMonth = shop.fiscalYearEndClosingMonth;
  if (fiscalYearEndClosingMonth !== undefined) {
    dict["fiscalYearEndClosingMonth"] = Json.encodeString(fiscalYearEndClosingMonth);
  }
  let legalForm = shop.legalForm;
  if (legalForm !== undefined) {
    dict["legalForm"] = Json.encodeString(legalForm);
  }
  let amountOfShareCapital = shop.amountOfShareCapital;
  if (amountOfShareCapital !== undefined) {
    dict["amountOfShareCapital"] = Json.encodeString(amountOfShareCapital);
  }
  let tvaNumber = shop.tvaNumber;
  if (tvaNumber !== undefined) {
    dict["tvaNumber"] = Json.encodeString(tvaNumber);
  }
  let siretNumber = shop.siretNumber;
  if (siretNumber !== undefined) {
    dict["siretNumber"] = Json.encodeString(siretNumber);
  }
  let rcsNumber = shop.rcsNumber;
  if (rcsNumber !== undefined) {
    dict["rcsNumber"] = Json.encodeString(rcsNumber);
  }
  let apeNafCode = shop.apeNafCode;
  if (apeNafCode !== undefined) {
    dict["apeNafCode"] = Json.encodeString(apeNafCode);
  }
  let bankCode = shop.bankCode;
  if (bankCode !== undefined) {
    dict["bankCode"] = Json.encodeString(bankCode);
  }
  let bankAccountHolder = shop.bankAccountHolder;
  if (bankAccountHolder !== undefined) {
    dict["bankAccountHolder"] = Json.encodeString(bankAccountHolder);
  }
  let bankAccountNumber = shop.bankAccountNumber;
  if (bankAccountNumber !== undefined) {
    dict["bankAccountNumber"] = Json.encodeString(bankAccountNumber);
  }
  let bicCode = shop.bicCode;
  if (bicCode !== undefined) {
    dict["bicCode"] = Json.encodeString(bicCode);
  }
  let ibanNumber = shop.ibanNumber;
  if (ibanNumber !== undefined) {
    dict["ibanNumber"] = Json.encodeString(ibanNumber);
  }
  let invoicingEndpointId = shop.invoicingEndpointId;
  if (invoicingEndpointId !== undefined) {
    dict["invoicingEndpointId"] = Json.encodeString(invoicingEndpointId);
  }
  let invoicingEndpointIdSchemeCode = shop.invoicingEndpointIdSchemeCode;
  if (invoicingEndpointIdSchemeCode !== undefined) {
    dict["invoicingEndpointIdSchemeCode"] = Json.encodeString(invoicingEndpointIdSchemeCode);
  }
  let invoicingEndpointIdSchemeType = shop.invoicingEndpointIdSchemeType;
  if (invoicingEndpointIdSchemeType !== undefined) {
    dict["invoicingEndpointIdSchemeType"] = Json.encodeString(invoicingEndpointIdSchemeType);
  }
  let taxationRegime = shop.taxationRegime;
  if (taxationRegime !== undefined) {
    dict["taxationRegime"] = Json.encodeString(taxationRegime);
  }
  let employeesNumber = shop.employeesNumber;
  if (employeesNumber !== undefined) {
    dict["employeesNumber"] = Json.encodeString(employeesNumber);
  }
  let logoUri = shop.logoUri;
  if (logoUri !== undefined) {
    dict["logoUri"] = Json.encodeString(logoUri);
  }
  return Json.encodeDict(dict);
}

function decodeShopKind(value) {
  return Stdlib_Option.getOr(Stdlib_Option.flatMap(Json.decodeString(value), Auth__Types.ShopKind.fromString), "INDEPENDENT");
}

function decodeInvoicingEndpointIdSchemeType(value) {
  let match = Json.decodeString(value);
  if (match === undefined) {
    return;
  }
  switch (match) {
    case "BE_BCE" :
      return "BE_BCE";
    case "BE_TVA" :
      return "BE_TVA";
    case "FR_SIREN" :
      return "FR_SIREN";
    case "FR_SIREN_SIRET" :
      return "FR_SIREN_SIRET";
    case "FR_SIREN_SIRET_CODEROUTAGE" :
      return "FR_SIREN_SIRET_CODEROUTAGE";
    case "FR_SIREN_SUFFIX" :
      return "FR_SIREN_SUFFIX";
    default:
      return;
  }
}

function decodeTaxationRegime(value) {
  let match = Json.decodeString(value);
  if (match === undefined) {
    return;
  }
  switch (match) {
    case "BASIC_VAT_EXEMPTION" :
      return "BASIC_VAT_EXEMPTION";
    case "NORMAL_MONTHLY" :
      return "NORMAL_MONTHLY";
    case "NORMAL_QUARTERLY" :
      return "NORMAL_QUARTERLY";
    case "OTHER" :
      return "OTHER";
    case "SIMPLIFIED" :
      return "SIMPLIFIED";
    default:
      return;
  }
}

function decodeEmployeesNumber(value) {
  let match = Json.decodeString(value);
  if (match === undefined) {
    return;
  }
  switch (match) {
    case "AT_LEAST_251" :
      return "AT_LEAST_251";
    case "FROM_11_TO_20" :
      return "FROM_11_TO_20";
    case "FROM_1_TO_10" :
      return "FROM_1_TO_10";
    case "FROM_21_TO_50" :
      return "FROM_21_TO_50";
    case "FROM_51_TO_250" :
      return "FROM_51_TO_250";
    default:
      return;
  }
}

function decodeShop(json) {
  let dict = Json.decodeDict(json);
  if (dict === undefined) {
    return;
  }
  let shop;
  try {
    shop = {
      id: Json.decodeDictFieldExn(dict, "id", Json.decodeString),
      kind: Stdlib_Option.getOr(Json.decodeDictOptionalField(dict, "kind", decodeShopKind), "INDEPENDENT"),
      name: Json.decodeDictFieldExn(dict, "name", Json.decodeString),
      corporateName: Json.decodeDictFieldExn(dict, "corporateName", Json.decodeString),
      address: Json.decodeDictFieldExn(dict, "address", Json.decodeString),
      postalCode: Json.decodeDictFieldExn(dict, "postalCode", Json.decodeString),
      city: Json.decodeDictFieldExn(dict, "city", Json.decodeString),
      country: Json.decodeDictFieldExn(dict, "country", Json.decodeString),
      phoneNumber: Json.decodeDictFieldExn(dict, "phoneNumber", Json.decodeString),
      email: Json.decodeDictFieldExn(dict, "email", Json.decodeString),
      legalRepresentative: Json.decodeDictOptionalField(dict, "legalRepresentative", Json.decodeString),
      logoUri: Json.decodeDictOptionalField(dict, "logoUri", Json.decodeString),
      activeWebDeviceId: Json.decodeDictFieldExn(dict, "activeWebDeviceId", Json.decodeString),
      loyaltyAddonActivated: Stdlib_Option.getOr(Json.decodeDictOptionalField(dict, "loyaltyAddonActivated", Json.decodeBoolean), false),
      bankName: Json.decodeDictOptionalField(dict, "bankName", Json.decodeString),
      cityOfRegistryOffice: Json.decodeDictOptionalField(dict, "cityOfRegistryOffice", Json.decodeString),
      website: Json.decodeDictOptionalField(dict, "website", Json.decodeString),
      fiscalYearEndClosingMonth: Json.decodeDictOptionalField(dict, "fiscalYearEndClosingMonth", Json.decodeString),
      legalForm: Json.decodeDictOptionalField(dict, "legalForm", Json.decodeString),
      amountOfShareCapital: Json.decodeDictOptionalField(dict, "amountOfShareCapital", Json.decodeString),
      tvaNumber: Json.decodeDictOptionalField(dict, "tvaNumber", Json.decodeString),
      siretNumber: Json.decodeDictOptionalField(dict, "siretNumber", Json.decodeString),
      rcsNumber: Json.decodeDictOptionalField(dict, "rcsNumber", Json.decodeString),
      apeNafCode: Json.decodeDictOptionalField(dict, "apeNafCode", Json.decodeString),
      bankCode: Json.decodeDictOptionalField(dict, "bankCode", Json.decodeString),
      bankAccountHolder: Json.decodeDictOptionalField(dict, "bankAccountHolder", Json.decodeString),
      bankAccountNumber: Json.decodeDictOptionalField(dict, "bankAccountNumber", Json.decodeString),
      bicCode: Json.decodeDictOptionalField(dict, "bicCode", Json.decodeString),
      ibanNumber: Json.decodeDictOptionalField(dict, "ibanNumber", Json.decodeString),
      invoicingEndpointId: Json.decodeDictOptionalField(dict, "invoicingEndpointId", Json.decodeString),
      invoicingEndpointIdSchemeCode: Json.decodeDictOptionalField(dict, "invoicingEndpointIdSchemeCode", Json.decodeString),
      invoicingEndpointIdSchemeType: Json.decodeDictOptionalField(dict, "invoicingEndpointIdSchemeType", decodeInvoicingEndpointIdSchemeType),
      taxationRegime: Json.decodeDictOptionalField(dict, "taxationRegime", decodeTaxationRegime),
      employeesNumber: Json.decodeDictOptionalField(dict, "employeesNumber", decodeEmployeesNumber)
    };
  } catch (_exn) {
    return;
  }
  return shop;
}

function encode(state) {
  if (typeof state !== "object") {
    return;
  }
  if (state.TAG === "Logging") {
    return;
  }
  let auth = state._0;
  let json = {};
  json["user"] = encodeUser(auth.user);
  let shops = auth.shops.map(encodeShop);
  json["shops"] = Json.encodeArray(shops);
  let shop = auth.activeShop;
  if (shop !== undefined) {
    json["activeShop"] = encodeShop(shop);
  }
  return Json.encodeDict(json);
}

function stringify(state) {
  return Stdlib_Option.map(encode(state), Json.stringify);
}

function decode(json) {
  let auth = Json.decodeDict(json);
  let user = Json.flatDecodeDictField(auth, "user", decodeUser);
  let shops = Stdlib_Option.getOr(Stdlib_Option.map(Json.flatDecodeDictField(auth, "shops", Json.decodeArray), shops => Stdlib_Array.filterMap(shops, decodeShop)), []);
  let activeShop = Stdlib_Option.flatMap(Stdlib_Option.flatMap(Stdlib_Option.flatMap(auth, json => json["activeShop"]), decodeShop), activeShop => shops.find(shop => shop.id === activeShop.id));
  if (user !== undefined && shops.length !== 0) {
    return {
      TAG: "Ok",
      _0: {
        user: user,
        shops: shops,
        activeShop: activeShop
      }
    };
  } else {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
}

function parse(string) {
  let json;
  try {
    json = Json.parseExn(string);
  } catch (exn) {
    return {
      TAG: "Error",
      _0: undefined
    };
  }
  return decode(json);
}

function make(state, action) {
  if (typeof action !== "object") {
    return {
      TAG: "Update",
      _0: "Unlogged"
    };
  }
  switch (action.TAG) {
    case "LogRequested" :
      let impersonate = action.impersonate;
      let jwt = action.jwt;
      let tmp;
      tmp = typeof state !== "object" || state.TAG === "Logging" || impersonate !== undefined && impersonate ? ({
          TAG: "Logging",
          jwt: jwt,
          impersonating: impersonate
        }) : state;
      return {
        TAG: "UpdateWithSideEffects",
        _0: tmp,
        _1: self => {
          Future.get(Future.all2([
            Auth__Fetcher.fetchUser(jwt),
            Auth__Fetcher.fetchShopsWithWebDevice(jwt)
          ]), result => {
            if (typeof state === "object" && state.TAG !== "Logging") {
              let user = result[0];
              if (user.TAG !== "Ok") {
                return self.dispatch("LogFailed");
              }
              let shops = result[1];
              if (shops.TAG !== "Ok") {
                return self.dispatch("LogFailed");
              }
              let shops$1 = shops._0;
              let match = Stdlib_Option.flatMap(state._0.activeShop, activeShop => shops$1.find(param => param.id === activeShop.id));
              return self.dispatch({
                TAG: "LogSucceeded",
                _0: {
                  user: user._0,
                  shops: shops$1,
                  activeShop: match !== undefined ? match : (
                      shops$1.length !== 1 ? undefined : shops$1[0]
                    )
                }
              });
            }
            let user$1 = result[0];
            if (user$1.TAG !== "Ok") {
              return self.dispatch("LogFailed");
            }
            let shops$2 = result[1];
            if (shops$2.TAG !== "Ok") {
              return self.dispatch("LogFailed");
            }
            let shops$3 = shops$2._0;
            self.dispatch({
              TAG: "LogSucceeded",
              _0: {
                user: user$1._0,
                shops: shops$3,
                activeShop: shops$3.length !== 1 ? undefined : shops$3[0]
              }
            });
          });
        }
      };
    case "LogSucceeded" :
      let auth = action._0;
      if (typeof state !== "object" || state.TAG === "Logging" || Stdlib_Option.map(encode(state), Json.stringify) !== Stdlib_Option.map(encode({
          TAG: "Logged",
          _0: auth
        }), Json.stringify)) {
        return {
          TAG: "Update",
          _0: {
            TAG: "Logged",
            _0: auth
          }
        };
      } else {
        return "NoUpdate";
      }
    case "ActiveShopSet" :
      if (typeof state !== "object") {
        return "NoUpdate";
      }
      if (state.TAG === "Logging") {
        return "NoUpdate";
      }
      let auth$1 = state._0;
      return {
        TAG: "Update",
        _0: {
          TAG: "Logged",
          _0: {
            user: auth$1.user,
            shops: auth$1.shops,
            activeShop: action._0
          }
        }
      };
  }
}

let fetchUser = Auth__Fetcher.fetchUser;

let fetchShopsWithWebDevice = Auth__Fetcher.fetchShopsWithWebDevice;

export {
  fetchUser,
  fetchShopsWithWebDevice,
  encodeUser,
  decodeUser,
  encodeShop,
  decodeShopKind,
  decodeInvoicingEndpointIdSchemeType,
  decodeTaxationRegime,
  decodeEmployeesNumber,
  decodeShop,
  encode,
  stringify,
  decode,
  parse,
  make,
}
/* Auth__Types Not a pure module */
